"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatGusCheckedAt = formatGusCheckedAt;
exports.GusStatusBadge = GusStatusBadge;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
/**
 * Mapa stanu na wygląd. Warianty dobrane do intencji makiety, nie do jej hexów:
 * `warning` (bursztyn) = „zajmij się tym, ale to nie awaria"; `danger` = awaria
 * odpytania; `success` = zgodne; `secondary` = cicha lista; `dark` = wykreślony
 * z rejestru (mocne, ale nie alarmowe); `info` = nieznany w rejestrze; `light`
 * z obwódką = jeszcze nie pytaliśmy.
 *
 * GPO-3: same NAZWY stanów leżą w `MainSetup.GusStatus`, bo bierze je stamtąd także
 * filtr na liście podmiotów. Tu zostaje wyłącznie wygląd. Napis na plakietce jest
 * dokładnie ten sam co dotąd — brzmienie zatwierdził właściciel i nie wolno go ruszać.
 */
const GUS_BADGE_LOOK = {
    DIFF: { bg: "warning", text: "dark", prefix: "⚠️ " },
    DIFF_MINOR: { bg: "secondary", text: "light" },
    OK: { bg: "success", text: "light" },
    CLOSED: { bg: "dark", text: "light" },
    NOT_FOUND: { bg: "info", text: "dark" },
    ERROR: { bg: "danger", text: "light" },
    NOT_CHECKED: { bg: "light", text: "dark", className: "border" },
};
/** Napis na plakietce: „GUS: " przed nazwą stanu (przedrostek dołożony wobec makiety). */
function gusBadgeLabel(status) {
    const { prefix = "" } = GUS_BADGE_LOOK[status];
    return `${prefix}GUS: ${MainSetupReact_1.default.GusStatus[status]}`;
}
/** Data sprawdzenia przychodzi z serwera jako ISO; pokazujemy sam dzień, po polsku. */
function formatGusCheckedAt(checkedAt) {
    if (!checkedAt)
        return null;
    const asDate = checkedAt instanceof Date ? checkedAt : new Date(checkedAt);
    if (Number.isNaN(asDate.getTime()))
        return null;
    const dd = String(asDate.getDate()).padStart(2, "0");
    const mm = String(asDate.getMonth() + 1).padStart(2, "0");
    return `${dd}-${mm}-${asDate.getFullYear()}`;
}
function GusStatusBadge({ status, checkedAt, }) {
    const resolved = status && GUS_BADGE_LOOK[status] ? status : "NOT_CHECKED";
    const { bg, text, className } = GUS_BADGE_LOOK[resolved];
    const badge = (react_1.default.createElement(react_bootstrap_1.Badge, { bg: bg, text: text, className: className }, gusBadgeLabel(resolved)));
    const checked = formatGusCheckedAt(checkedAt);
    if (!checked)
        return badge;
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "gus-status-tooltip" },
            "Sprawdzono w GUS: ",
            checked) }, badge));
}
